import { Section } from '../containers/section';
import { ConditionSectionContent } from '../review/condition-section';
import { PatientInfoSectionContent } from '../review/patient-info-section';
import { useTranslation } from '@/contexts/i18n-context';
import styles from './treatment-sections.module.css';
import { Button } from '../button';
import { useEncounter } from '@/contexts/encounter-context';

const translationBase = 'visit.treatmentPlan.intakeDetails';

interface IntakeSectionProps {
  encounterCancelled: boolean;
}
export function IntakeSection(props: IntakeSectionProps) {
  return (
    <Section title={<IntakeSectionTitle {...props} />}>
      <div className={styles.intakeSubSection}>
        <PatientInfoSectionContent />
      </div>

      <ConditionSectionContent
        showEditButton={false}
        sectionsClassName={styles.intakeSubSectionExpandable}
      />
    </Section>
  );
}

function IntakeSectionTitle({ encounterCancelled }: IntakeSectionProps) {
  const { t } = useTranslation();
  const { encounter } = useEncounter();

  return (
    <div className={styles.intakeSectionTitle}>
      <h2 className="h4">{t(`${translationBase}.title`)}</h2>
      {!encounterCancelled && (
        <Button
          variant="link"
          rightIcon="chevron_right"
          as="a"
          to={`/visit/${encounter.id}/tx-plan/details`}
        >
          {t(`${translationBase}.viewAllDetails`)}
        </Button>
      )}
    </div>
  );
}
